<template>
    <GuestBar
        v-if="!user"
        @loginClick="setModal(Modals.login.code)"
        @registerClick="setModal(Modals.register.code)"
    />
    <UserBar
        v-else
        :user="user"
        @depositClick="setModal(Modals.depositRequest.code)"
        @withdrawalClick="setModal(Modals.withdrawalRequest.code)"
    />
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import { errorGuard } from '@app/utils';
    import GuestBar from './components/GuestBar';
    import UserBar from './components/UserBar';

    export default {
        name: 'AuthContainer',
        data() {
            return {
                Modals,
            };
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            onLogout() {
                errorGuard({
                    action: this.logout
                });
            },
        },
        components: {
            GuestBar,
            UserBar
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/authentication/AuthContainer.vue